export const LOG_LOCATION = 'issue.issue-context-service';
